import type { IValidationError, TFunction } from '@wyz/types';
import { FormMethods } from '@wyz/ui';
import { useOnUpdate } from '@wyz/utils';
import { FieldValues } from 'react-hook-form';
import { Validations } from '~/common/helpers';
import { CommonErrorCodesEnumType } from '~/common/types';

type Args<
  TFieldValues extends FieldValues = FieldValues,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TContext = any,
  TTransformedValues = TFieldValues,
> = {
  methods: FormMethods<TFieldValues, TContext, TTransformedValues>;
  errors?: null | IValidationError<CommonErrorCodesEnumType>[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: TFunction<any>;
};
export const useValidationForm = <
  TFieldValues extends FieldValues = FieldValues,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TContext = any,
  TTransformedValues = TFieldValues,
>(
  args: Args<TFieldValues, TContext, TTransformedValues>,
) => {
  useOnUpdate(() => {
    if (args.errors) {
      Validations.setFormErrors({
        setError: args.methods.setError,
        errors: Validations.formatValidationErrors(args.errors, args.t),
      });
    }
  }, [args.errors, args.methods.setError, args.t]);
};
